import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
const SvgGermanyFormal = (props)=>/*#__PURE__*/ _jsxs("svg", {
        enableBackground: "new 0 0 512 512",
        viewBox: "0 0 512 512",
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        width: "1em",
        height: "1em",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "m400 0h-288c-61.9 0-112 50.1-112 112v58.7h512v-58.7c0-61.9-50.1-112-112-112z",
                fill: "#464655"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m0 400c0 61.9 50.1 112 112 112h288c61.9 0 112-50.1 112-112v-58.7h-512z",
                fill: "#ffe15a"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "m0 170.7h512v170.7h-512z",
                fill: "#ff4b55"
            }),
            /*#__PURE__*/ _jsxs("g", {
                fill: "#fff",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "m140.8 322.7c-4.8 0-9.9-.3-15.4-1-5.4-.7-10.7-1.6-15.7-2.8s-9.5-2.6-13.4-4.1c-4.1-1.6-6.9-4-8.6-7.1-1.6-3.1-2.3-6.4-1.9-10 .4-3.5 1.6-6.7 3.6-9.5s4.8-4.7 8.2-5.8 7.3-.7 11.6 1c4.4 1.8 9.7 3.2 15.7 4.4 6 1.1 11.3 1.7 15.9 1.7 7.3 0 12.3-.8 15-2.5 2.7-1.6 4-3.5 4-5.7 0-2-.9-3.7-2.8-5-1.8-1.3-5.2-2.5-10.2-3.5l-22.8-4.9c-24.2-5.2-36.3-18.1-36.3-38.6 0-9.1 2.5-17 7.4-23.8 4.9-6.7 11.8-11.9 20.7-15.7 8.9-3.7 19.2-5.6 31-5.6 6 0 12.3.6 19 1.9s12.5 3.1 17.3 5.5c3.4 1.6 5.9 4 7.5 7s2.2 6.2 2 9.5c-.3 3.3-1.3 6.2-3.1 8.8s-4.4 4.4-7.7 5.3-7.3.6-12-1c-3.2-1.1-7-2.1-11.4-2.8s-8.5-1-12.2-1c-6.2 0-10.9.9-14 2.7s-4.7 4.1-4.7 7c0 1.6.9 3.1 2.7 4.5 1.8 1.3 5.2 2.5 10.3 3.5l22.8 4.9c24.2 5.3 36.3 17.9 36.3 37.8 0 9-2.4 16.9-7.3 23.7s-11.7 12-20.5 15.7c-8.8 3.6-19.1 5.5-31 5.5z"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "m258.2 322.3c-6.6 0-11.7-1.8-15.2-5.4s-5.3-8.8-5.3-15.5v-96c0-6.7 1.8-11.9 5.3-15.5s8.6-5.4 15.2-5.4 11.6 1.8 15.1 5.4 5.2 8.8 5.2 15.5v96c0 6.7-1.7 11.9-5.1 15.5s-8.5 5.4-15.2 5.4z"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "m344.1 320.4c-6.8 0-12.1-1.8-15.7-5.4s-5.4-8.8-5.4-15.7v-91.8c0-6.8 1.8-12.1 5.4-15.7s8.8-5.4 15.7-5.4h62.7c10.5 0 15.8 5.2 15.8 15.6s-5.3 15.6-15.8 15.6h-44.8v19.2h40.5c10.5 0 15.8 5.2 15.8 15.6s-5.3 15.6-15.8 15.6h-40.5v21.3h44.8c10.5 0 15.8 5.2 15.8 15.6s-5.3 15.6-15.8 15.6h-62.7z"
                    })
                ]
            })
        ]
    });
export { SvgGermanyFormal };
